import React from 'react';

export const ServiceIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path
      d="M15 2.5H5C3.625 2.5 2.5 3.625 2.5 5V15C2.5 16.375 3.625 17.5 5 17.5H15C16.375 17.5 17.5 16.375 17.5 15V5C17.5 3.625 16.375 2.5 15 2.5ZM13.75 10.625L9.375 15L8.125 13.75L10.875 11H6.25V9H10.875L8.125 6.25L9.375 5L13.75 9.375C14 9.625 14 10.375 13.75 10.625Z"
      fill="#004660"
    />
  </svg>
);

export const UserIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path
      d="M13.33 15V13.33C13.33 12.45 12.98 11.61 12.36 10.99C11.74 10.37 10.9 10.02 10.02 10.02H6.71C5.83 10.02 4.99 10.37 4.37 10.99C3.75 11.61 3.4 12.45 3.4 13.33V15"
      fill="#FDFDFD"
    />
    <path
      d="M8.33 7.5C9.71 7.5 10.83 6.38 10.83 5C10.83 3.62 9.71 2.5 8.33 2.5C6.95 2.5 5.83 3.62 5.83 5C5.83 6.38 6.95 7.5 8.33 7.5Z"
      fill="#FDFDFD"
    />
  </svg>
);

export const TrashIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path
      d="M15.83 7.5V15.83H4.17V7.5H15.83ZM14.17 2.5H5.83L5 3.33H2.5V5H17.5V3.33H15L14.17 2.5ZM17.5 5.83H2.5V15.83C2.5 16.75 3.25 17.5 4.17 17.5H15.83C16.75 17.5 17.5 16.75 17.5 15.83V5.83Z"
      fill="#FDFDFD"
    />
  </svg>
);

export const UserGroupIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path
      d="M10 10C12.07 10 13.75 8.32 13.75 6.25C13.75 4.18 12.07 2.5 10 2.5C7.93 2.5 6.25 4.18 6.25 6.25C6.25 8.32 7.93 10 10 10ZM10 11.875C7.5 11.875 2.5 13.125 2.5 15.625V17.5H17.5V15.625C17.5 13.125 12.5 11.875 10 11.875Z"
      fill="#FDFDFD"
    />
  </svg>
);

export const OnlineIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path
      d="M15.83 2.5H4.17C3.24 2.5 2.5 3.24 2.5 4.17V15.83C2.5 16.76 3.24 17.5 4.17 17.5H15.83C16.76 17.5 17.5 16.76 17.5 15.83V4.17C17.5 3.24 16.76 2.5 15.83 2.5ZM4.17 15.83V4.17H15.83L15.834 15.83H4.17Z"
      fill="#FDFDFD"
    />
  </svg>
);

export const ArrowIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path
      d="M7.5 13.75L12.5 10L7.5 6.25"
      stroke="#004660"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
